// extracted by mini-css-extract-plugin
export var tabWrapper = "Tabs-module--tabWrapper--093de";